/** Logos for short-term rental sites shown beside listing links. */
export const PLATFORM_LOGOS: Record<string, string> = {
  airbnb: "/str-platforms/airbnb.svg",
  vrbo: "/str-platforms/vrbo.svg",
  booking: "/str-platforms/booking.svg",
  "booking.com": "/str-platforms/booking.svg",
  marriott: "/str-platforms/marriott.svg",
  "marriott homes & villas": "/str-platforms/marriott.svg",
};

const HOST_PLATFORMS: { suffix: string; platform: string }[] = [
  { suffix: "airbnb.com", platform: "airbnb" },
  { suffix: "vrbo.com", platform: "vrbo" },
  { suffix: "booking.com", platform: "booking" },
  { suffix: "homes-and-villas.marriott.com", platform: "marriott" },
];

export function platformKey(platform: string): string {
  return platform.trim().toLowerCase();
}

export function platformLogo(platform: string): string | null {
  return PLATFORM_LOGOS[platformKey(platform)] ?? null;
}

function hostMatches(host: string, suffix: string): boolean {
  return host === suffix || host.endsWith(`.${suffix}`);
}

/** Platform key when the URL host is a short-term rental site we have a logo for. */
export function platformFromUrl(value: string): string | null {
  let host: string;
  try {
    host = new URL(value).hostname.toLowerCase();
  } catch {
    return null;
  }
  for (const { suffix, platform } of HOST_PLATFORMS) {
    if (hostMatches(host, suffix)) return platform;
  }
  if (host.includes("homes-and-villas") && hostMatches(host, "marriott.com")) {
    return "marriott";
  }
  return null;
}
